import React from "react"
import { Container, Row, Col } from "reactstrap"
import UnitSkeleton from "components/Skeleton/UnitSkeleton"
import useMediaQuery from "hooks/useWindowSize"

const DAYS = 3
const DEFAULT_SLOT_COUNT = 4
const STAGES_COUNT = 5
const DATE_COUNT = 1

const ProductionScheduleSkeleton = () => {
   // Media query for screens ≤ 1440px
   const isSmallScreen = useMediaQuery("(max-width: 1440px)")
   const SLOT_COUNT = isSmallScreen ? 1 : DEFAULT_SLOT_COUNT

   return (
      <Container fluid className="production-skeleton p-0 px-1 w-full">
         {/* Header Row */}
         <Row className="mb-0 production-skeleton-row">
            <Col xs={2} className="p-2">
               <UnitSkeleton styleClass="w-100" shape="rect" size="medium" />
            </Col>
            {Array.from({ length: DAYS }).map((_, dayIndex) => (
               <Col xs={3} key={dayIndex}>
                  <Row>
                     {Array.from({ length: DATE_COUNT }).map(
                        (_, stageIndex) => (
                           <Col
                              xs={12}
                              className="p-2"
                              key={`${dayIndex}-${stageIndex}`}
                           >
                              <div className="d-flex w-100 justify-content-between align-items-center w-full flex-wrap gap-3">
                                 <UnitSkeleton
                                    styleClass="w-100"
                                    shape="rect"
                                    size="medium"
                                 />
                              </div>
                           </Col>
                        )
                     )}
                  </Row>
               </Col>
            ))}
         </Row>

         {/* Stages Rows */}
         {Array.from({ length: STAGES_COUNT }).map((_, index) => (
            <Row key={index} className="mb-2 production-skeleton-row">
               <Col xs={2} className="production-skeleton-row-stage">
                  <div className="d-flex w-100 justify-content-between align-items-center w-full flex-wrap gap-3">
                     <UnitSkeleton
                        styleClass="w-100"
                        shape="rect"
                        size="medium"
                     />
                  </div>
               </Col>
               {Array.from({ length: DAYS }).map((_, dayIndex) => (
                  <Col xs={3} key={dayIndex}>
                     <Row className="px-1 production-skeleton-row-day">
                        {Array.from({ length: SLOT_COUNT }).map(
                           (_, slotIndex) => (
                              <Col
                                 xs={SLOT_COUNT === 1 ? 12 : 3}
                                 key={`${dayIndex}-${slotIndex}`}
                                 className="production-skeleton-row-day-slot"
                              >
                                 <div className="d-flex w-100 justify-content-between align-items-center w-full flex-wrap gap-3">
                                    <UnitSkeleton
                                       styleClass="w-100"
                                       shape="rect"
                                       size="small"
                                    />
                                 </div>
                              </Col>
                           )
                        )}
                     </Row>
                  </Col>
               ))}
            </Row>
         ))}
      </Container>
   )
}

export default ProductionScheduleSkeleton
